module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('closeModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('closeModal')
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [(_vm.recordingProcessing === true) ? _c('a', [_vm._v("\n                Recording Processing\n            ")]) : _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("Open Meeting "), (_vm.hasRecording === true) ? _c('span', [_vm._v("Archive ")]) : _vm._e(), _c('i', {
    staticClass: "fa fa-share"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Attending (" + _vm._s(_vm.attending.length) + " / " + _vm._s(_vm.maxParticipants) + ")")]), _vm._v(" "), _c('ul', {
    staticClass: "students"
  }, _vm._l((_vm.attending), function(student, $index) {
    return _c('li', [_c('div', {
      staticClass: "avatar"
    }, [(student.user.avatar) ? _c('img', {
      attrs: {
        "src": student.user.avatar
      }
    }) : _c('img', {
      attrs: {
        "src": "static/static/img/mentorship-avatar.jpg"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('span', [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s($index + 1) + ". ")]), _vm._v(_vm._s(_vm._f("trim")(student.user.firstName)) + " " + _vm._s(_vm._f("trim")(student.user.lastName)))])])])
  }))]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Waitlist (" + _vm._s(_vm.waitListed.length) + ")")]), _vm._v(" "), _c('ul', {
    staticClass: "students"
  }, _vm._l((_vm.waitListed), function(student, $index) {
    return _c('li', [_c('div', {
      staticClass: "avatar"
    }, [(student.user.avatar) ? _c('img', {
      attrs: {
        "src": student.user.avatar
      }
    }) : _c('img', {
      attrs: {
        "src": "static/static/img/mentorship-avatar.jpg"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('span', [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(_vm.attending.length + $index + 1) + ". ")]), _vm._v("\n                                " + _vm._s(student.user.firstName) + " " + _vm._s(student.user.lastName) + "\n                            ")])])])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1492e5be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GlobalMeetingParticipants.vue
// module id = 1980
// module chunks = 2